import { FETCH_INCIDENT_DETAIL } from "../../actions/actionTypes";

const initialState = {  
    incidentDetail: {},
    loading: false,
};

const reducer = (state = initialState, action) => {
    
    switch (action.type) {    
        case FETCH_INCIDENT_DETAIL.REQUEST:
            return {...state,loading: true}
        case FETCH_INCIDENT_DETAIL.FAILURE:
            return {...state, loading: false}
        case FETCH_INCIDENT_DETAIL.SUCCESS:             
            return {...state, incidentDetail: action.obj.data, loading: false}    
        default:
            return state
    }
}

export default reducer;